import { Box, VStack, Flex, Text } from '@chakra-ui/react'
import React from 'react'

interface HourProps {
    hour: number
    isPM?: boolean
    shouldHideMinutes?: boolean
    isLast?: boolean
}

const HourSlot: React.FC<HourProps> = ({
    hour,
    isPM,
    shouldHideMinutes,
    isLast,
}) => {
    const Line: React.FC = () => (
        <Box zIndex={-1} mx={4} flex={1} h="1px" backgroundColor="gray.100" />
    )

    return (
        <VStack spacing={8} mb={isLast ? 4 : 8}>
            {(!shouldHideMinutes ? ['00', '15', '30', '45'] : ['00']).map(
                minutes => (
                    <Flex key={hour + minutes} w="100%" align="center" h="24px">
                        <Label
                            hour={hour}
                            minutes={minutes}
                            isPM={Boolean(isPM)}
                        />
                        <Line />
                    </Flex>
                )
            )}
        </VStack>
    )
}

const Label: React.FC<{ hour: number; minutes: string; isPM: boolean }> = ({
    hour,
    minutes,
    isPM,
}) => {
    const isHourStart = minutes === '00'

    return (
        <Flex
            justify="flex-end"
            w={{ base: '48px', md: '74px' }}
            align="center"
        >
            <Text
                display={{ base: 'none', md: 'block' }}
                fontWeight={isHourStart ? 'bold' : 'normal'}
                color={isHourStart ? 'gray.800' : 'gray.400'}
                fontSize={isHourStart ? '14px' : '14px'}
            >{`${hour}:${minutes} ${isPM ? 'PM' : 'AM'}`}</Text>
            <Text
                display={{ base: 'block', md: 'none' }}
                fontWeight="bold"
                fontSize="14px"
                color="gray.800"
            >
                {isHourStart ? `${hour} ${isPM ? 'PM' : 'AM'}` : ''}
            </Text>
        </Flex>
    )
}

export default HourSlot
